import { Component } from 'react';
import type { ErrorInfo, ReactNode } from 'react';
import styles from './ErrorBoundary.module.css';

interface Props {
    children?: ReactNode;
}

interface State {
    hasError: boolean;
    error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            hasError: false,
        };
    }

    public static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    public componentDidCatch(_error: Error, _errorInfo: ErrorInfo) {
        // Log error to error reporting service
    }

    public render() {
        const { hasError } = this.state;
        const { children } = this.props;

        if (hasError) {
            return (
                <div className={styles.container}>
                    <div className={styles.card}>
                        <h1 className={styles.title}>مشکلی پیش آمد</h1>
                        <p className={styles.message}>
                            خطای غیرمنتظره‌ای رخ داد. لطفاً صفحه را دوباره
                            بارگذاری کنید.
                        </p>
                        <button
                            type="button"
                            className={styles.button}
                            onClick={() => {
                                window.location.reload();
                            }}
                        >
                            تلاش مجدد
                        </button>
                    </div>
                </div>
            );
        }

        return children;
    }
}

export default ErrorBoundary;
